import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { DeleteForever, PreviewActive, ResourceDocument } from '@/assets/icons';
import { colors, otherColors } from '@/styles/colors';
import { media } from '@/styles/theme';
import { ATTACHMENT_PREFIX_REGEX } from '@/config/variables';

interface IProps {
  fileName: string;
  actions?: {
    preview?: string;
    delete?: () => void;
  };
}

const Attachment = ({ fileName, actions }: IProps): React.ReactElement => {
  const { t } = useTranslation();

  const parsedName = fileName.replace(ATTACHMENT_PREFIX_REGEX, '');

  return (
    <Container>
      <IconContainer>
        <FileIcon />
      </IconContainer>
      <FileDetails>
        <FileName>{parsedName}</FileName>
        <ActionsContainer>
          {actions?.preview && (
            <ActionPreview href={actions.preview} download={parsedName} target="_blank">
              <ActionIcon src={PreviewActive} />
              {t`resources.files.preview`}
            </ActionPreview>
          )}
          {actions?.delete && (
            <ActionDelete onClick={actions.delete}>
              <ActionIcon src={DeleteForever} />
              {t`resources.files.delete`}
            </ActionDelete>
          )}
        </ActionsContainer>
      </FileDetails>
    </Container>
  );
};

export { Attachment };

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid ${colors.gray.c200};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
  padding: 8px;
`;

const FileName = styled.span`
  flex: auto;
  font-size: 12px;
  font-weight: 500;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  height: 18px;
`;

const FileIcon = styled.div`
  width: 12px;
  height: 15px;
  margin-right: 14px;

  mask-image: url(${ResourceDocument});
  mask-size: contain;
  background-repeat: no-repeat;
  background-color: ${otherColors.lxc.darkBlue};
`;

const ActionPreview = styled.a`
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  color: ${otherColors.lxc.blue};
  cursor: pointer;

  /* padding: 0;
  border: none;
  background: none; */
`;

const ActionDelete = styled(ActionPreview)`
  color: ${otherColors.lxc.red};
`;

const FileDetails = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex: auto;
  overflow: hidden;
  gap: 4px;

  ${media.tablet} {
    flex-wrap: nowrap;
  }
`;

const ActionsContainer = styled.div`
  display: flex;
  gap: 16px;
  height: 16px;
`;

const ActionIcon = styled.img`
  margin-right: 4px;
  height: 12px;
`;
